const InfoMessageRecipientTypes = {
    All: 1,
    Approver: 3
};

Object.freeze(InfoMessageRecipientTypes);

export default InfoMessageRecipientTypes;